import {
  Button,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  Box,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addShipmentToGroupage,
  createGroupage,
  updateGroupage,
} from "../features/groupages/groupageSlices";

const initialState = {
  description: "",
};

const GroupageFormDialog = (props) => {
  const dispatch = useDispatch();
  const { groupage, open, handleClose } = props;
  const { isLoading, isSuccess, isError, message } = useSelector(
    (state) => state.groupages
  );
  const [formData, setFormData] = useState(groupage ?? initialState);
  const handleFormDataChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };
  const handleSubmit = (e) => {
    if (!isLoading) {
      e.preventDefault();
      if (!groupage?.id) {
        dispatch(createGroupage(formData));
      } else {
        dispatch(updateGroupage(formData));
      }
    }
  };

  useEffect(() => {
    if (isSuccess && !isLoading && !isError) {
      setFormData(groupage ?? initialState);
      handleClose();
    }
  }, [isError, isSuccess, isLoading, message]);
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      slotProps={{
        paper: {
          component: "form",
          onSubmit: (event) => {
            event.preventDefault();
            handleClose();
          },
        },
      }}
    >
      <DialogTitle>
        {!groupage?.id ? "Create New Consolidation" : "Edit Consolidation"}
      </DialogTitle>
      <DialogContent>
        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            autoFocus
            required
            margin="dense"
            id="description"
            name="description"
            label="Consolidation Name"
            type="text"
            fullWidth
            variant="standard"
            value={formData.description}
            onChange={handleFormDataChange}
            onSubmit={handleSubmit}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button type="submit" onClick={handleSubmit} disabled={isLoading}>
          {!groupage?.id ? "Create" : "Update"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GroupageFormDialog;
